Object.defineProperty(exports,"__esModule",{value:true});exports.default=













makeClassMemberDecorator;function makeClassMemberDecorator(decorate){
return function decorateClassMember(target,name,descriptor){var
configurable=descriptor.configurable,enumerable=descriptor.enumerable,value=descriptor.value,_get=descriptor.get,initializer=descriptor.initializer;
if(value){
return{
configurable:configurable,
enumerable:enumerable,
value:decorate(value)};

}


if(_get||initializer){
return{
configurable:configurable,
enumerable:enumerable,
get:function get(){


if(this===target){
return null;
}

var resolvedValue=initializer?initializer.apply(this,[]):_get.apply(this,[]);
var decoratedValue=decorate(resolvedValue).bind(this);

Object.defineProperty(this,name,{
configurable:configurable,
enumerable:enumerable,
value:decoratedValue});


return decoratedValue;
}};

}

throw new Error('called makeClassMemberDecorator on unsupported descriptor');
};
}